<!--  -->
<template>
    <nuxt-link :to="$t('prefix')+'interview/'+data.id">
        <div class='interview-card'>
            <div class="img">
                <img class="card-bg" :src="data.thumbnailUrl" alt="">
            </div>
            <img class="card-icon" src="/image/interview/icon_2.png" alt="">
            <div class="card-title">
                <div ref="title" class="card-title-text" :title="data.title">

<!--                  <div>-->
<!--                    -->
<!--                  </div>-->
<!--                  <span class="ellipsis-after"> ... </span>-->
                  {{data.title}}

                </div>
            </div>
        </div>
    </nuxt-link>
</template>

<script>

    export default {
        components: {},
        data() {
            return {

            };
        },
        filters: {
        },
        props: {
            data: {
                type: Object,
                default: {}
            }
        },
        computed: {},
        watch: {},
        methods: {
          wordlimit(){ //参数分别为：类名，要显示的字符串长度
            if(this.$refs.title.innerHTML.length>50){
              this.$refs.title.innerHTML = this.$refs.title.innerHTML.substr(0,40)+' ...'
            }
            }
        },
        created() {

        },
        mounted() {
        },

        activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
    }
</script>
<style lang='scss' scoped>
    .interview-card {
        width: 232px;
        height: 320px;
        position: relative;
        overflow: hidden;
        cursor: pointer;

        &:hover {
            .img {
                transform: scale(1.1);
            }
        }

        .img {
            position: absolute;
            transition: all .5s ease-in;

            .card-bg {
                width: 232px;
                height: 260px;
                object-fit: cover;
                border: none;
                outline: none;
            }
        }

        .card-icon {
            width: 40px;
            height: 40px;
            position: absolute;
            right: 10px;
            bottom: 84px;
        }

        .card-title {
            width: 232px;
            max-height: 60px;
            display: flex;
            align-items: center;
            background: #0D51FF;
            box-shadow: 0px 4px 5px 0px rgba(0, 0, 0, 0.05);
            position: absolute;
            bottom: 0;
            padding: 0 10px;
            color: #FFFFFF;
            .card-title-text {
              height: 60px;
                position: relative;
                overflow: hidden;
                 line-height: 30px;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
                font-size: 16px;
                font-family: Source Han Sans CN;
                font-weight: 400;
                color: #FFFFFF;
            }
          //
          //.card-title-text {
          //  max-height: 50px;
          //  line-height: 25px;
          //  width: 100%;
          //  overflow: hidden;
          //  margin: 10px;
          //}
          //.card-title-text:before {
          //  content: "";
          //  float: left;
          //  width: 5px;
          //  height: 50px;
          //}
          //.card-title-text > *:first-child {
          //  float: right;
          //  width: 100%;
          //  margin-left: -30px;
          //}
          //.ellipsis-after {
          //  content: "\02026";
          //  box-sizing: content-box;
          //  -webkit-box-sizing: content-box;
          //  -moz-box-sizing: content-box;
          //  float: right;
          //  position: relative;
          //  top: -25px;
          //  left: 100%;
          //  width: 50px;
          //  margin-left: -50px;
          //  padding-right: 30px;
          //  text-align: right;
          //  background-size: 100% 100%;
          //}

        }
    }
</style>